/**
 * 无归属的服务端错误（21f）：Worker 的 'chat/serverError' 推送 → GlobalState.serverError。
 *
 * 这条通道对应旧版 `_handleRealtimeError` 的「uuid 为空」那一支：error_msg 既没
 * 匹配上在途发送/编辑、也没回滚在途置顶时，旧版直接弹 SnackBar 展示服务端原文，
 * 而新版此前整条丢弃——用户侧完全静默（21f 之前的 bug）。
 *
 * 与会话无关，所以挂在 GlobalState 顶层而不是 timeline 切片里；UI 用 seq 变化
 * 触发一次性 toast（与 editFailedSeq 同口径：值本身不是状态，变化才是事件）。
 */
import type { GlobalStore } from './global';
import type { AppWorkerHost } from './authState';

export interface ServerErrorSlice {
  /** 自增事件序号；0 = 本次会话还没出现过。UI 比对上次值决定是否弹 */
  readonly seq: number;
  /** 服务端 error_msg 原文（Worker 已保证非空） */
  readonly message: string;
}

export const SERVER_ERROR_NONE: ServerErrorSlice = { seq: 0, message: '' };

export interface ServerErrorConnection {
  dispose(): void;
}

export function connectServerError(
  store: GlobalStore,
  host: AppWorkerHost,
): ServerErrorConnection {
  const off = host.onPush('chat/serverError', (push) => {
    store.set((prev) => ({
      ...prev,
      serverError: { seq: prev.serverError.seq + 1, message: push.message },
    }));
  });
  return {
    dispose() {
      off();
    },
  };
}
